export default __webpack_public_path__ + "static/media/Headphone.f328f09c.svg";